class AuthenticationService {
    constructor($http, globalConstants, $location) {
        this.$http = $http;
        this.globalConstants = globalConstants;
        this.$location = $location;
    }
    
    getUserType(){
        if(this.isTrainer()){
            return "Trainer";
        }
        if(this.isAdminUser()){
            return "Admin";
        }
        if(this.isSuperUser()){
            return "Super Admin";
        }
        return "Trainee";
    }

    isTrainer() {
        var decodedToken = this.getDecodedToken();
        return decodedToken ? decodedToken.includes('"Trainer":') : false;
    }

    isAdminUser() {
        var decodedToken = this.getDecodedToken();
        return decodedToken ? decodedToken.includes('"Admin":') : false;
    }

    isSuperUser() {
        var decodedToken = this.getDecodedToken();
        return decodedToken ? decodedToken.includes('"SuperAdmin":') : false;
    }

    onLogout() {
        localStorage.removeItem('token');
        this.$http.defaults.headers.common.Authorization = '';
        this.$location.path('/login');
    }

    isAuthenticated() {
        return this.getDecodedToken() != null;
    }

    getDecodedToken(){
        //Not ideal but it works and saves a call to the server just to get the user type
        var token = this.getToken();
        if(token){
            //Remove unnecessary base64 so it decodes correctly
            token = token.replace("Bearer", "");
            token = token.substr(0, token.lastIndexOf("."));
            token = token.replace('.','');
            return atob(token);
        }
        return null;
    }

    requestToken(request) {
        return this.$http.post(this.globalConstants.ApiBaseUrl + "/api/authentication/requesttoken", request);
    }

    setToken(token) {
        //Store token in local storage
        localStorage.setItem('token', token);
        //Add token to auth header for $http
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + token;
    }

    getToken() {
        return localStorage.getItem('token');
    }
}

export default AuthenticationService;


// WEBPACK FOOTER //
// ./src/js/services/authentication.service.js